import { config } from './config';
export function workerFactory() {
    return new Worker(config.WORKER_URL);
}
//# sourceMappingURL=web_worker.js.map